import { Box, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material"
import { useAppSelector } from "../../app/hooks"
import { selectAuthUser, selectIsNotOrgUser } from "../auth/AuthSlice"
import { epochToDate } from "../utils/DateUtil"
import { grey } from "@mui/material/colors"

const Profile = () => {
  const authUser = useAppSelector(selectAuthUser)
  const isNotOrgUser = useAppSelector(selectIsNotOrgUser)
  return <>
    <Typography variant="h3">
      Preferences
    </Typography>
    <Typography variant="subtitle2">
      {authUser?.displayName} | {authUser?.email}
    </Typography>
    <TableContainer component={Box}>
      <Table sx={{ maxWidth: 550 }} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell>Name</TableCell>
            <TableCell align="right">Option</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell>Paid tier</TableCell>
            <TableCell align="right">{authUser?.paidTier}</TableCell>
          </TableRow>
          {isNotOrgUser ?
            <TableRow>
              <TableCell>Number of reports you can run</TableCell>
              <TableCell align="right">{authUser?.paidTierCount}</TableCell>
            </TableRow>
            : <TableRow>
              <TableCell>Number of reports your Org can run
                {<Typography sx={{ color: grey[500] }} variant="caption"><br />Your limit (in org)</Typography>}
              </TableCell>
              <TableCell align="right">{authUser?.org?.paidTierCount}
                {<Typography sx={{ color: grey[500] }} variant="caption"><br />{authUser?.orgPaidTierCount === 0 ? '' : authUser?.orgPaidTierCount}</Typography>}
              </TableCell>
            </TableRow>}
          {authUser?.paidTierExpiry ? <TableRow>
            <TableCell>Expires on</TableCell>
            <TableCell align="right">{epochToDate(authUser?.paidTierExpiry * 1000)}</TableCell>
          </TableRow> : <></>}
        </TableBody>
      </Table>
    </TableContainer>
  </>
}

export default Profile